/* global window, document, CustomEvent */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Form as ReactForm } from 'react-form';
import { compose } from 'recompose';
import Form from '../../components/Form';
import Fieldset from '../../components/Fieldset';
import SuggestField from '../../components/Fields/SuggestField';
import Formrow from '../../components/Formrow';
import { List, ListItem } from '../../components/List';
import VaccinationToolHandler from './VaccinationToolHandler';
import VaccinationToolResults from './VaccinationToolResults';
import { withContextPath } from '../../components/contextpath';
import { withGoogleAnalytics, googleAnalyticsShape } from '../../components/googleAnalytics';
import { withAppState } from '../../components/store';
import { appStateShape } from './AppStore';

class VaccinationToolForm extends PureComponent {
    static propTypes = {
        contextPath: PropTypes.string,
        appState: appStateShape.isRequired,
        googleAnalytics: googleAnalyticsShape.isRequired,
    };

    static defaultProps = {
        contextPath: '',
    };

    static triggerOnSelectionEvent(match) {
        if (!match) return;

        const customEvent = new CustomEvent('vaccination-tool-selection', {
            detail: {
                country: match,
            },
        });

        document.dispatchEvent(customEvent);
    }

    constructor(props) {
        super(props);

        this.values = [];
        this.state = {
            countrySearchTerm: '',
            countryDetail: {},
            isLoadingVaccinations: false,
            vaccinationSuggestions: [],
        };
    }

    componentDidMount() {
        this.props.googleAnalytics.onLoad();
    }


    componentWillReceiveProps(nextProps) {
        const { countries } = nextProps.appState;

        if (countries.length && window.location.hash && window.location.hash.length > 1) {
            this.loadCountryByName(countries);
        }
    }

    onFormChange = ({ values }) => {
        this.values = values;
    };

    onFormSubmit(e) {
        e.preventDefault();
        const suggestions = this.state.vaccinationSuggestions;

        if (suggestions && suggestions.length) {
            this.onVaccinationCountriesChangeRequested(suggestions[0].value);
            document.getElementById('country-suggest').blur();
        }
    }

    onVaccinationCountriesFetchRequested = ({ value }) => {
        if (this.state.countrySearchTerm === value) return;

        this.setState({
            countrySearchTerm: value,
        });

        if (!value || value.length < 3) {
            this.setState({
                vaccinationSuggestions: [],
                countryDetail: {},
            });
            return;
        }

        const { countries } = this.props.appState;
        const suggestions = [];

        countries.forEach((country) => {
            const countryName = country.name.toLocaleLowerCase();
            const searchValue = value.toLocaleLowerCase();

            if (countryName.indexOf(searchValue) >= 0) {
                suggestions.push({
                    label: country.name,
                    value: country.uid,
                });
            }
        });

        this.setState({
            vaccinationSuggestions: suggestions,
        });
    };

    onVaccinationCountriesClearRequested = () => {
        this.setState({
            vaccinationSuggestions: [],
        });
    };

    onVaccinationCountriesChangeRequested = (countryId) => {
        if (!countryId) {
            this.setState({
                countrySearchTerm: '',
                countryDetail: {},
                isLoadingVaccinations: false,
            });

            return;
        }

        const vaccationSearch = new VaccinationToolHandler({
            contextPath: this.props.contextPath,
        });

        this.setState({
            countryDetail: {},
            isLoadingVaccinations: true,
        });

        vaccationSearch
            .search(countryId)
            .then((data) => {
                this.constructor.triggerOnSelectionEvent(data);

                this.setState({
                    countrySearchTerm: data.name,
                    countryDetail: data,
                    isLoadingVaccinations: false,
                });
            });
    };

    loadCountryByName(newCountries) {
        if (!newCountries || !newCountries.length) return;
        const countryName = window.location.hash.substr(1);
        const countryFromHash = decodeURI(countryName.toLocaleLowerCase());

        const match = newCountries
            .find(country => countryFromHash === country.name.toLocaleLowerCase());

        if (match) {
            this.onVaccinationCountriesChangeRequested(match.uid);
            window.location.hash = '';
        }
    }

    noResultsMessage() {
        if (!this.state.isLoadingVaccinations
            && this.state.countrySearchTerm.length >= 3
            && !this.state.vaccinationSuggestions.length
            && !this.state.countryDetail.name) {
            return (
                <div>
                    <p>
                        Für „<strong>{this.state.countrySearchTerm}</strong>“
                        gibt es leider kein Ergebnis.
                    </p>
                    <p>Bitte</p>
                    <List>
                        <ListItem>
                            prüfen Sie, ob sich ein Schreibfehler eingeschlichen hat.
                        </ListItem>
                        <ListItem>
                            tippen Sie die deutsche Bezeichnung Ihres Reiselandes ein.
                        </ListItem>
                        <ListItem>
                            geben Sie ein Land ein und nicht einen
                            Kontinent, eine Region oder Insel.
                        </ListItem>
                    </List>

                    <Formrow
                        label="Oder suchen Sie Ihr Reiseziel einfach in der Länderliste:"
                        type="select"
                        htmlFor="country-select"
                    >
                        <select
                            name="country-select"
                            onChange={e => this
                                .onVaccinationCountriesChangeRequested(e.target.value)}
                        >
                            <option value="">Bitte wählen Sie ein Land aus</option>
                            {this.props.appState.countries.map(country => (
                                <option
                                    value={country.uid}
                                    key={country.uid}
                                >{country.name}
                                </option>
                            ))}
                        </select>
                    </Formrow>
                </div>
            );
        }

        return '';
    }

    render() {
        const {
            onVaccinationCountriesFetchRequested,
            onVaccinationCountriesClearRequested,
            onVaccinationCountriesChangeRequested,
        } = this;

        const { isLoadingCountries } = this.props.appState;

        return (
            <React.Fragment>
                <ReactForm
                    defaultValues={this.values}
                    onChange={this.onFormChange}
                >
                    <Form
                        className="vaccination-tool-form"
                        onSubmit={e => this.onFormSubmit(e)}
                        onChange={this.props.googleAnalytics.onChange}
                    >
                        <Fieldset className="vaccination-tool-form__suggest-fieldset">
                            <SuggestField
                                value={this.state.countrySearchTerm}
                                field="country-suggest"
                                label="Wo geht's hin?"
                                onChange={
                                    onVaccinationCountriesChangeRequested
                                }
                                onSuggestionsFetchRequested={
                                    onVaccinationCountriesFetchRequested
                                }
                                onSuggestionsClearRequested={
                                    onVaccinationCountriesClearRequested
                                }
                                suggestions={this.state.vaccinationSuggestions}
                                isLoading={isLoadingCountries}
                            />
                        </Fieldset>

                        {this.noResultsMessage()}
                    </Form>
                </ReactForm>
                {this.state.isLoadingVaccinations ? 'Rufe Daten ab…' : ''}
                {this.state.countryDetail.name ? (
                    <VaccinationToolResults countryDetail={this.state.countryDetail} />
                ) : ''}
            </React.Fragment>
        );
    }
}

export default compose(
    withGoogleAnalytics,
    withContextPath,
    withAppState,
)(VaccinationToolForm);



// WEBPACK FOOTER //
// ./src/frontend/apps/VaccinationTool/VaccinationToolForm.jsx